import { render, staticRenderFns } from "./taxesList.vue?vue&type=template&id=7b51a09c"
import script from "./taxesList.vue?vue&type=script&lang=js"
export * from "./taxesList.vue?vue&type=script&lang=js"
import style0 from "./taxesList.vue?vue&type=style&index=0&id=7b51a09c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports